// extracted by mini-css-extract-plugin
export default {"booklet":"BookLet_booklet__vZCQt","wrapper":"BookLet_wrapper__Zphub","adjustable_max":"BookLet_adjustable_max__LLQX6","page":"BookLet_page__d2VkM","row":"BookLet_row__O2g9a"};